"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityTableCell = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const PriorityTableCell = ({ children, color, hover = false, ToolTipProps, TypographyProps: typographyPropsProp = {}, ...rest }) => {
    const typographyProps = {
        color: "inherit",
        ...typographyPropsProp,
        sx: theme => ({
            alignItems: "center",
            backgroundColor: color,
            display: "flex",
            height: "100%",
            justifyContent: "center",
            ml: hover ? 0.25 : 0,
            minHeight: theme.spacing(6.5),
            "tr:hover &": {
                boxShadow: hover ? `-${2}px 0 ${color}` : "unset",
            },
            transition: theme.transitions.create("box-shadow", {
                duration: theme.transitions.duration.shortest,
            }),
            width: theme.spacing(2),
        })
    };
    return (react_1.default.createElement(TableCell_1.default, { padding: "none", sx: { height: "inherit" }, ...rest },
        react_1.default.createElement(Tooltip_1.default, { title: ToolTipProps ? ToolTipProps.title : children, enterDelay: 500, placement: "right", PopperProps: { style: { position: "fixed" } }, ...ToolTipProps },
            react_1.default.createElement(Typography_1.default, { ...typographyProps }, children))));
};
exports.PriorityTableCell = PriorityTableCell;
exports.default = exports.PriorityTableCell;
